 $(document).ready(function () {
$('.testimonial-slider').slick({
  dots:false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  prevArrow: $('.custom-prev'),
  nextArrow: $('.custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        centerMode: false,
      }
    },
    {
      breakpoint: 980,
      settings: {
        centerMode: false,
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 767,
      settings: {
         centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});

// new arrivals section

$('.arrival_slider').slick({
  dots:false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: $('.custom-prev'),
  nextArrow: $('.custom-next'),
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    
  ]
});


});

// Rotation gallery Script Start 

document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll('.gallery-img');

  images.forEach((img) => {
    img.addEventListener('mouseenter', () => {
      img.classList.add('rotate');

      const others = [...images].filter(i => i !== img);
      const randomImg = others[Math.floor(Math.random() * others.length)];

      randomImg.classList.add('rotate');

      img.addEventListener('mouseleave', () => {
        img.classList.remove('rotate');
        randomImg.classList.remove('rotate');
      }, { once: true });
    });
  });
});


// Rotation gallery Script End


$(document).ready(function () {
	function updateTitle() {
		let newTitle = $(".banner_section h1").text().trim();
		$(".banner_section h1").attr("title", newTitle);
	}

	// Run once on load
	updateTitle();

	// Watch for text changes
	const targetNode = document.querySelector(".banner_section h1");
	const observer = new MutationObserver(updateTitle);

	observer.observe(targetNode, {
		childList: true,
		characterData: true,
		subtree: true
	});

});


 // Gallery Popop JS Start

  document.addEventListener("DOMContentLoaded", () => {
  const imgs = [...document.querySelectorAll(".s-popup-gallery-area .gallery-img img")];
  if (!imgs.length) return;

  const popup = document.createElement("div");
  popup.className = "s-gallery-popup";
  popup.innerHTML = `
    <button class="close">&times;</button>
    <span class="prev">&#171;</span>
    <img src="" alt="">
    <span class="next">&#187;</span>
  `;
  document.body.appendChild(popup);

  const imgEl = popup.querySelector("img");
  let current = 0;
  const showImg = i => { imgEl.src = imgs[i].src; popup.classList.add("active"); document.body.style.overflow="hidden"; current=i; };
  const closePopup = () => { popup.classList.remove("active"); document.body.style.overflow=""; };

  imgs.forEach((img, i) => img.addEventListener("click", () => showImg(i)));
  popup.querySelector(".close").onclick = closePopup;
  popup.querySelector(".next").onclick = () => showImg((current + 1) % imgs.length);
  popup.querySelector(".prev").onclick = () => showImg((current - 1 + imgs.length) % imgs.length);
  popup.addEventListener("click", e => { if (e.target === popup) closePopup(); });
});

 // Gallery Popop JS End

